import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useSelector } from 'react-redux';

import configurations from '@/config';
import { getAccessToken } from '@/utils/api';

import { endpoints } from '../endpoints';

export const useSubmitWriteback = () => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (clinicalNoteId: string) => {
      const { data } = await axios.post(
        `${configurations.API_URL}/videa-notes/${clinicalNoteId}/writeback`,
        {},
        {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
            'Content-Type': 'application/json',
            practice: currentPracticeId,
            org: currentOrganizationId,
          },
        },
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([
        endpoints.ambient.voiceNotes.batchNotesByUnifiedAppointmentIds,
      ]);
      queryClient.invalidateQueries([
        endpoints.ambient.voiceNotes.batchNotesByStandalonePatientVisitIds,
      ]);
    },
  });
};
